export default __webpack_public_path__ + "static/media/car-form-success.6ad6da83.svg";